import { render, staticRenderFns } from "./VideoPlaylistPreview.vue?vue&type=template&id=837caf96&scoped=true&"
import script from "./VideoPlaylistPreview.vue?vue&type=script&lang=js&"
export * from "./VideoPlaylistPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837caf96",
  null
  
)

export default component.exports